import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { manifest } from "@/docs/manifest";
import { Group, Text } from "@mantine/core";

export const SidebarHeadline = ({
  title,
  label = "Getting Started",
  docPath,
}: {
  title: string;
  label?: string;
  docPath: keyof typeof manifest;
}) => {
  return (
    <Group justify="space-between">
      <Text fw={"bold"} fz={"md"}>
        {title}
      </Text>
      <LabelExplainer
        lh={"inherit"}
        inline
        showIcon={true}
        label={label}
        explanation={<Doc path={docPath} />}
      />
    </Group>
  );
};
